import script from "./ElectronicInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./ElectronicInvoice.vue?vue&type=script&setup=true&lang=js"

import "./ElectronicInvoice.vue?vue&type=style&index=0&id=bce59e24&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bce59e24"]])

export default __exports__